<template>
  <div class="modal stories" :class="{ active: showModal }">
    <div v-if="curHistory" class="stories-top">
      <div class="stories-title">
        <div class="stories-title__image">
          <img
            v-if="curHistory.poster"
            :src="curHistory.poster"
            :alt="curHistory.name"
          />
          <NoImage v-else />
        </div>
        <div class="stories-title__text">
          <div class="stories-title__name">
            {{ curHistory.name }}
          </div>
          <div class="stories-title__date">
            {{ storyDate }}
          </div>
        </div>
      </div>
      <div class="stories-close" @click="$emit('modal', 'stories')">
        <div class="modal-top__back-Link">
          <CloseIcon />
        </div>
      </div>
    </div>
    <div class="stories-container" v-cloak>
      <div v-if="curHistory?.stories?.length > 0">
        <Swiper
          :slides-per-view="1"
          :space-between="0"
          :pagination="{ horizontalClass: 'history-bullets' }"
          :modules="modules"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <SwiperSlide
            v-for="story in curHistory.stories"
            :key="story.id"
            :data-viev="story.is_viewed_by_auth_user"
            :data-slide="index"
            :data-date="story.published_at"
            class="stories__item"
          >
            <video
              :id="`video_${curHistory.id}_${story.id}`"
              :data-story="story.id"
              nocontrols
              playsinline
              controlsList="nodownload nofullscreen"
              poster=""
              @click="playPause($event)"
              :src="story.file_url ? story.file_url : ''"
              :type="`video/${story.file_type ? story.file_type : 'mp4'}`"
            >
              <div>
                <span>Формат видео не поддерживается. </span>
                <a :href="story.file_url">Скачать</a>.
              </div>
            </video>
          </SwiperSlide>
        </Swiper>
      </div>
      <InlineLoader class="story-loader" />
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/components/icons/CloseIcon.vue';
import NoImage from '@/components/blocks/noimage/NoImage.vue';
import InlineLoader from '@/components/blocks/loader/InlineLoader.vue';
import { watchHistory } from '@/functions/API';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  name: 'StoriesModal',
  components: {
    CloseIcon,
    NoImage,
    Swiper,
    SwiperSlide,
    InlineLoader,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    history: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      curHistory: null,
      storyDate: '',
    };
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show() {
      this.showModal = this.show;
      this.curHistory = this.history;
    },
  },
  methods: {
    async playPause(event) {
      var videoElem = event.target;
      if (videoElem) {
        if (videoElem.paused) {
          this.playVideo(videoElem);
        } else {
          videoElem.pause();
        }
      }
    },
    async playVideo(videoElem) {
      try {
        await videoElem.play();
      } catch (err) {
        console.log(err);
      }
    },
    onSwiper(swiper) {
      const unwatchedSlides = swiper.slides.filter(
        (slide) => slide.getAttribute('data-viev') == 'false',
      );
      if (unwatchedSlides.length > 0) {
        const unwatchedSlideIdx = swiper.slides.findIndex(
          (slide) => slide.getAttribute('data-viev') == 'false',
        );
        swiper.slideTo(unwatchedSlideIdx, 0);
      } else {
        swiper.slideTo(0, 0);
      }
      const curSlide = swiper.slides[swiper.activeIndex];
      const curVideo = curSlide
        ? curSlide.getElementsByTagName('video')[0]
        : null;
      const prevSlide = swiper.slides[swiper.previousIndex];
      const prevVideo = prevSlide
        ? prevSlide.getElementsByTagName('video')[0]
        : null;
      this.storyDate = this.dateBuild(curSlide.getAttribute('data-date'));
      watchHistory(parseInt(curVideo.getAttribute('data-story')), () => {
        if (prevVideo && !prevVideo.paused) {
          prevVideo.pause();
        }
        if (curVideo) {
          this.playVideo(curVideo);
          curVideo.onended = () => {
            if (swiper.isEnd) {
              this.$emit('modal', 'stories');
            } else {
              swiper.slideNext();
            }
          };
        }
      });
    },
    onSlideChange(swiper) {
      const curSlide = swiper.slides[swiper.activeIndex];
      const curVideo = curSlide.getElementsByTagName('video')[0];
      const prevSlide = swiper.slides[swiper.previousIndex];
      const prevVideo = prevSlide.getElementsByTagName('video')[0];
      this.storyDate = this.dateBuild(curSlide.getAttribute('data-date'));
      watchHistory(parseInt(curVideo.getAttribute('data-story')), () => {
        if (!prevVideo.paused) {
          prevVideo.pause();
        }
        if (curVideo) {
          this.playVideo(curVideo);
          curVideo.onended = () => {
            if (swiper.isEnd) {
              this.$emit('modal', 'stories');
            } else {
              swiper.slideNext();
            }
          };
        }
      });
    },
    dateBuild(date) {
      const parseDate = new Date(date);
      const yyyy = parseDate.getFullYear();
      let mm = parseDate.getMonth() + 1;
      let dd = parseDate.getDate();
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      return dd + '-' + mm + '-' + yyyy;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100vh;
}
.stories {
  position: fixed;
  left: 0;
  top: -120%;
  height: 100%;
  width: 100%;
  background-color: #000000;
  transition: 0.3s ease-in-out;
  &.active {
    top: 0;
  }
  &-top {
    position: absolute;
    z-index: 3;
    background-color: transparent;
    color: #ffffff;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding-top: 32px;
    padding-left: 16px;
    padding-right: 16px;
  }
  &-title {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #ffffff;
    &__image {
      background-color: var(--color-gray-light);
      border-radius: 50%;
      overflow: hidden;
      img,
      svg {
        display: block;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        object-fit: cover;
      }
      svg {
        width: 80%;
        height: 80%;
        color: var(--color-black);
      }
    }
    &__text {
      color: #ffffff;
    }
    &__name {
      color: #ffffff;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 133%;
    }
    &__date {
      color: #cccccc;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 133%;
    }
  }
  &-close {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
      display: block;
      width: 17px;
      height: 17px;
      min-width: 17px;
      min-height: 17px;
    }
  }
  &-container {
    width: 100%;
    height: 100vh;
  }
  &__item {
    background: #000000;
    video {
      width: 100%;
      height: 100vh;
      object-fit: contain;
    }
  }
  .story-loader {
    height: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
<style lang="scss">
.history-bullets {
  top: 20px !important;
  bottom: auto !important;
  display: flex;
  padding-left: 16px;
  padding-right: 16px;
  .swiper-pagination-bullet {
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: var(--color-white-opacity);
    &-active {
      background: var(--color-blue);
    }
  }
}
</style>
